import { colors } from '../../../../utils'

/**
 * Estilos del Report Modal (sx only, sin makeStyles).
 */
export const useStyles = () => {
  return {
    styles: {
      dialog: {
        '& .MuiDialog-paper': {
          borderRadius: 2,
          overflowX: 'hidden',
          minWidth: 480,
        },
      },
      dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        pt: 1,
      },
      titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        pr: 0,
      },
      title: {
        fontSize: 18,
        fontWeight: 700,
        color: colors.primary,
      },
      twoColumnsLayout: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        gap: 0,
      },
      leftColumn: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        pr: 2,
      },
      rightColumn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pl: 2,
      },
      verticalDivider: {
        width: '1px',
        alignSelf: 'stretch',
        flexShrink: 0,
        bgcolor: 'divider',
      },
      recipientLabel: {
        fontWeight: 700,
        fontSize: 16,
        color: 'text.primary',
      },
      relativeFields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        mt: 0.5,
        pl: 1,
      },
      generateButton: {
        mt: 1,
      },
      pdfIconButton: {
        width: 64,
        height: 64,
        borderRadius: '50%',
        border: `2.5px solid ${colors.primary}`,
        color: colors.primary,
        '&:hover': {
          backgroundColor: 'rgba(0,112,111,0.06)',
        },
      },
      pdfIconLabel: {
        fontSize: 11,
        fontWeight: 600,
        color: colors.primary,
        textAlign: 'center',
        mt: 1,
        lineHeight: 1.4,
      },
    },
  }
}
